import { scroll } from "motion";

document.addEventListener("DOMContentLoaded", function () {
    const animatedSloganSections = document.querySelectorAll(".animated-slogan");

    if (animatedSloganSections.length === 0) return;

    animatedSloganSections.forEach((section) => {
        const contentElement = section.querySelector(".animated-slogan__content");
        const wrapperElement = section.querySelector(".animated-slogan__wrapper");

        if (!contentElement || !wrapperElement) return;

        let stopScrollAnimation;

        const setupAnimation = () => {
            if (stopScrollAnimation) {
                stopScrollAnimation();
            }

            contentElement.style.transform = "";

            const textWidth = contentElement.scrollWidth;
            const visibleWidth = wrapperElement.clientWidth;

            contentElement.style.transform = `translateX(24px)`;

            if (textWidth > visibleWidth) {
                const scrollAmount = textWidth - visibleWidth;
                const extraBuffer = 70;
                const slideDistance = -(scrollAmount + extraBuffer);

                stopScrollAnimation = scroll(
                    (progress) => {
                        const effectiveProgress = Math.min(progress * 1.5, 1);
                        const currentX = 24 + effectiveProgress * slideDistance;
                        contentElement.style.transform = `translateX(${currentX}px)`;
                    },
                    {
                        target: section,
                        offset: ["start 50vh", "end 20vh"],
                    }
                );
            }
        };

        if (document.fonts) {
            document.fonts.ready.then(setupAnimation);
        } else {
            window.addEventListener("load", setupAnimation);
        }

        let resizeTimer;
        window.addEventListener("resize", () => {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(setupAnimation, 250);
        });
    });
});
